var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle2E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32__2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M326.8,83.1L326.8,83.1L326.8,83.1C327,83,327,83,326.8,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5,126.2c-0.8-7.4-3.9-15.4-8-21.5c-2.7,5.1-4.4,7.6-7.8,11.5c1.9-15.9-10-31.5-23.6-32.6 c3.9,5.5,1.1,16.5-6.1,21.5l-0.1,0.1c7-12.1-1-24.5-9.9-27.2c-0.1,0-0.3-0.1-0.4-0.1c1.6,7.4-4.2,16.3-9.6,20.7 c0.3-11.7-13.2-22.4-25.3-23c-1.9-0.1-3.7,0.1-5.4,0.5c0,0.1,0,0.2,0,0.4c1,11.7-7.3,22.7-12.3,25.4c-0.6-2.9-1-6.6-0.9-10.4 c0.1-2.9,0.5-5.9,1.5-8.4c-14.3,3.1-25.5,21.3-26.9,34.6l0,0c-2.4-1.5-5.1-8.8-4-13.4c-15.4,12.7-21.5,36-13.9,54.5 c8.5,20.7,34,24,55.3,19.2c1.2-0.3,2.3-0.4,3.5-0.5c2.7-0.2,5.2,0,7.6,0.4c4.8,0.8,9.5,2.4,14.6,3c1.8,0.2,3.6,0.4,5.5,0.3 c0.7,0,1.3-0.1,2-0.1c1.6-0.2,3.3-0.4,5-0.8c2-0.4,4-0.8,6-1.1c1.6-0.3,3.2-0.5,4.8-0.6c0.2,0,0.4,0,0.5,0 c2.9-0.1,5.9,0.1,8.8,0.1c3.1,0.1,6.2,0,9.1-0.6c7.6-1.6,18.9-6.8,24.5-17.4C435.3,149.3,435.9,139.3,434.5,126.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1E1918",
    d: "M320,101.6c1.4-3.4,3.2-6.8,5.3-10c0.1-2.9,0.5-5.9,1.5-8.4c-14.3,3.1-25.5,21.3-26.9,34.6l0,0 c2.5,25,16.3,50.1,40.9,59.7c2.7-0.2,5.2,0,7.6,0.4C322.4,163.2,310.2,129.8,320,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1918",
    d: "M326.8,83.1L326.8,83.1L326.8,83.1C327,83,327,83,326.8,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1918",
    d: "M362.3,115c0.7-2.7,1.3-5.3,1.8-7.8c0.1-2.3,0-4.6-0.3-7.2c-1.4-11-9.6-20.2-19.7-24.3 c-0.1,0-0.2-0.1-0.3-0.1c-1.9-0.1-3.7,0.1-5.4,0.5c0,0.1,0,0.2,0,0.4c31.4,12.4,8.9,45.6,9,67.9c-0.1,3.1,0,6.1,0.3,9.1 c1.1,11,5.3,20.9,15.3,27.3c1.8,0.2,3.6,0.4,5.5,0.3c0.7,0,1.3-0.1,2-0.1C347.6,166.4,355.9,136.2,362.3,115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1918",
    d: "M407.3,111.9c-1-3.2-2.2-6.3-3.6-9.3c0.8,3.1,1.4,6.1,1.8,9.2c1.4,23.6-5.3,46.9-19,66.7 c0.2,0,0.4,0,0.5,0c2.9-0.1,5.9,0.1,8.8,0.1C409.3,159.6,414.6,134.1,407.3,111.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1918",
    d: "M381.6,156.6c-2-8.7-4.9-17.6-3.2-26.9c1.5-8.6,6.2-16.9,10.7-24.6l-0.1,0.1c7-12.1-1-24.5-9.9-27.2 c9.3,11.7-2.2,27.4-5.5,39.2c-0.6,2.4-1.1,4.8-1.4,7.2c-1,7.3-0.6,14.8,1.3,21.7c0.8,3.1,1.8,6.2,2.6,9.3 c2.3,8.5,3.7,16.9-0.4,24.7c2-0.4,4-0.8,6-1.1C384.5,172.7,382.6,161.1,381.6,156.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle2E);
export default __webpack_public_path__ + "static/media/man_hairstyle_2e.8c48574517d502adb3c7031d4ee0fa08.svg";
export { ForwardRef as ReactComponent };